/* Impression SCDM — LE LETTRAGE DECOUPE : APERCU, CONTOUR, LAMINAGE.

   ============================================================================
   POURQUOI CE FICHIER EXISTE, ET POURQUOI IL N EST PAS DANS scdm.js
   ============================================================================
   Les trois correctifs du 9 septembre 2026 appartiennent logiquement a
   scdm.js — c est lui qui tient peindreApercu(), peindreChoix() et
   laminageOffert(). Ils sont ici parce que l outil d ecriture du theme ne
   peut pas reecrire un fichier de 77 ko d un seul tenant sans risquer de le
   tronquer. On a donc pris le chemin que scdm-forme.js emprunte deja et
   documente : on se branche sur le MEME contexte 2d que scdm.js
   (getContext('2d') rend toujours le meme objet pour une meme toile), et on
   corrige a la source, au moment ou le trait se pose.

   LE JOUR OU scdm.js POURRA ETRE REECRIT : remonter les trois correctifs
   dedans — estLettrage() a cote de couleurLettrageOfferte(), le fond et la
   teinte dans peindreApercu(), le curseur dans peindreChoix(), et
   « if (estLettrage()) return false; » en tete de laminageOffert() — puis
   supprimer ce fichier et son <script> dans snippets/scdm-minimum.liquid.

   ============================================================================
   CE QU IL CORRIGE
   ============================================================================
   1. L APERCU. Le lettrage n est pas imprime : on taille les lettres ou le
      logo dans un rouleau deja colore. L apercu montrait le dessin en
      quadrichromie sur un fond mat.base presque noir. Faux deux fois : la
      piece est d une seule teinte, et il n y a aucun fond.

   2. LE CURSEUR CONTOUR. Il regle la largeur du liston autour du dessin, et
      c est ce liston que la lame contourne. En decoupe il n y en a pas : les
      lettres sont taillees au ras du trace.

   3. LE LAMINAGE. Une pellicule ne se pose pas sur des lettres separees. La
      rangee s ouvrait des 144 po2 et proposait 4,00 $/pi2 + 30 $ de montage.

   ============================================================================
   LE PIEGE DU BOUTON MUET — 9 septembre 2026
   ============================================================================
   scdm-vierge.js tient la liste des choix obligatoires (GROUPES) et saute
   deja tout groupe dont la rangee est cachee (groupeVisible()). On ne cache
   ici que des choses qui ne sont PAS dans GROUPES : le curseur Contour n y a
   aucun groupe, le laminage non plus. Cacher l un ou l autre ne peut donc
   rien reclamer d invisible. On cache malgre tout de la meme facon que
   scdm.js — hidden ET display:none — pour que groupeVisible() sache lire nos
   rangees si l un d eux devenait obligatoire un jour.

   Charge depuis snippets/scdm-minimum.liquid, en defer, apres scdm-forme.js. */

(function () {
  'use strict';

  var MATIERE_LETTRAGE = 'lettrage';

  var cv = null, ctx = null, branche = false;
  var bordureGardee = null;

  function S() { return window.SCDM; }
  function etat() { var s = S(); return s && s.etat; }

  /* ------------------------------------------------------- le materiau */

  /* Le materiau retenu est-il du lettrage decoupe ? Meme repli que
     matiereOuRepli() dans scdm.js : un identifiant inconnu n est pas du
     lettrage, donc on ne cache rien par accident. */
  function estLettrage() {
    var e = etat(), D = window.SCDM_DATA;
    if (!e || !D || !D.MATIERES) return false;
    for (var i = 0; i < D.MATIERES.length; i++) {
      if (D.MATIERES[i].id === e.matiere) return D.MATIERES[i].id === MATIERE_LETTRAGE;
    }
    return false;
  }

  /* La teinte du rouleau. couleurLettrage vit dans l etat et COULEURS_LETTRAGE
     dans les donnees ; on relit les deux a chaque trait pour qu un changement
     de couleur se voie tout de suite. Blanc par defaut, comme scdm.js. */
  function teinte() {
    var e = etat(), D = window.SCDM_DATA;
    var l = (D && D.COULEURS_LETTRAGE) || [];
    if (!e || !l.length) return '#FFFFFF';
    for (var i = 0; i < l.length; i++) {
      if (l[i].id === e.couleurLettrage) return l[i].hex || '#FFFFFF';
    }
    return l[0].hex || '#FFFFFF';
  }

  /* ------------------------------------------------------- 1. L APERCU */

  /* La silhouette du fichier, en aplat de la teinte. On garde la FORME (le
     canal alpha) et on jette la couleur : on dessine l image dans une toile
     de cote, puis « source-in » remplace tout ce qui est opaque par un aplat.

     UNE IMAGE SANS TRANSPARENCE DONNE UN RECTANGLE PLEIN. C est le
     comportement juste : un JPG plein cadre n a pas de silhouette, et c est
     bien un rectangle de vinyle qui sortirait de la machine. L avertissement
     existe deja ailleurs — scdm-forme.js dit « ce fichier n a pas de fond
     transparent » sous l apercu — on ne le double pas ici. */
  function silhouetteDe(im, w, h, coul) {
    var lw = Math.max(1, Math.min(2048, Math.round(w)));
    var lh = Math.max(1, Math.min(2048, Math.round(h)));
    var oc = document.createElement('canvas');
    oc.width = lw; oc.height = lh;
    var o = oc.getContext('2d');
    if (!o) return null;
    try { o.drawImage(im, 0, 0, lw, lh); } catch (e) { return null; }
    o.globalCompositeOperation = 'source-in';
    o.fillStyle = coul;
    o.fillRect(0, 0, lw, lh);
    return oc;
  }

  /* Clarte perceptuelle d un #RRGGBB ou #RGB, entre 0 et 1. */
  function clarteDe(hex) {
    var s = String(hex || '').replace('#', '');
    if (s.length === 3) s = s[0] + s[0] + s[1] + s[1] + s[2] + s[2];
    if (s.length !== 6 || /[^0-9a-fA-F]/.test(s)) return 1;
    var r = parseInt(s.slice(0, 2), 16) / 255;
    var g = parseInt(s.slice(2, 4), 16) / 255;
    var b = parseInt(s.slice(4, 6), 16) / 255;
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
  }

  /* LA LISIBILITE DES TROIS COULEURS. Le fond reste neutre — celui du
     configurateur, comme demande — donc un lettrage blanc sur un apercu clair
     et un lettrage noir sur un apercu sombre disparaitraient. On pose autour
     de la silhouette un halo de la teinte OPPOSEE : sombre autour d un vinyle
     clair, clair autour d un vinyle fonce. Le halo epouse la forme (c est
     l ombre portee de la silhouette elle-meme, sans decalage), il ne depend
     d aucun theme, et il tient en mode jour comme en mode nuit. */
  function haloDe(hex) {
    return clarteDe(hex) > 0.55 ? 'rgba(10,16,26,.78)' : 'rgba(255,255,255,.92)';
  }

  /* ------------------------------------------------- le branchement 2d */

  /* TROIS TRAITS A REPRENDRE DANS peindreApercu(), ET RIEN D AUTRE :

     - ctx.fill()      le fond mat.base du support. Sur du lettrage il n y a
                       pas de fond : on ne pose pas le trait.
     - ctx.drawImage() le dessin du client, en couleurs. On le remplace par
                       sa silhouette en aplat, halo compris, AU MEME ENDROIT
                       et a la meme echelle : aucune geometrie recopiee.
     - ctx.fillRect()  le voile lustre, pose sur toute la toile apres l image.
                       Un aplat de vinyle n a pas de reflet a montrer.

     ON RECONNAIT CHAQUE TRAIT SANS DEVINER. peindreApercu() commence par
     clearRect(0,0,TC,TC) : c est le debut d un rendu, on remet le compteur a
     zero. Le fond est le PREMIER fill() du rendu ; le voile lustre est le seul
     fillRect() qui couvre la toile entiere. Les cotes, dessinees a la fin par
     dessinerCotes(), passent par pointe() (un fill() plus tardif) et par un
     fillRect() de la taille d une etiquette : elles ne sont jamais touchees. */
  function brancher() {
    if (branche || !ctx) return;
    branche = true;

    var vraiClear = ctx.clearRect.bind(ctx);
    var vraiFill = ctx.fill.bind(ctx);
    var vraiDraw = ctx.drawImage.bind(ctx);
    var vraiRect = ctx.fillRect.bind(ctx);

    var fonds = 0;   /* combien de fill() depuis le debut du rendu */

    ctx.clearRect = function (x, y, w, h) {
      if (x === 0 && y === 0 && w === cv.width && h === cv.height) fonds = 0;
      return vraiClear(x, y, w, h);
    };

    ctx.fill = function () {
      var premier = (fonds === 0);
      fonds++;
      /* Le fond du support, et lui seul. */
      if (premier && estLettrage() && arguments.length === 0) return;
      return vraiFill.apply(null, arguments);
    };

    ctx.drawImage = function (im, dx, dy, dw, dh) {
      var e = etat();
      if (arguments.length !== 5 || !e || !e.img || im !== e.img || !estLettrage()) {
        return vraiDraw.apply(null, arguments);
      }
      var coul = teinte();
      var sil = silhouetteDe(im, dw, dh, coul);
      if (!sil) return vraiDraw.apply(null, arguments);

      ctx.save();
      ctx.shadowColor = haloDe(coul);
      ctx.shadowBlur = Math.max(9, Math.min(cv.width, cv.height) * 0.032);
      ctx.shadowOffsetX = 0;
      ctx.shadowOffsetY = 0;
      /* Trois passes pour le halo : l ombre portee d une seule reste trop
         pale pour detacher un vinyle noir d un fond sombre, ou un vinyle
         blanc d un fond clair. Meme forme, meme place : rien ne deborde. */
      vraiDraw(sil, dx, dy, dw, dh);
      vraiDraw(sil, dx, dy, dw, dh);
      vraiDraw(sil, dx, dy, dw, dh);
      ctx.restore();
      /* La piece elle-meme, par-dessus son halo : un aplat franc. */
      vraiDraw(sil, dx, dy, dw, dh);
    };

    ctx.fillRect = function (x, y, w, h) {
      if (x === 0 && y === 0 && w === cv.width && h === cv.height && estLettrage()) return;
      return vraiRect(x, y, w, h);
    };
  }

  /* On redemande un rendu sans rien changer a l etat : c est le geste que
     scdm-forme.js utilise deja — reposer la valeur du curseur de contour,
     dont scdm.js ecoute l evenement « input ». */
  function redessiner() {
    var b = document.getElementById('scdmBordure');
    if (!b) return;
    b.dispatchEvent(new Event('input', { bubbles: true }));
  }

  /* --------------------------------------------------- 2. LE CONTOUR */

  /* Le libelle et le curseur sont deux freres dans .stage-tools, sans .fld
     autour : on les cache TOUS LES DEUX, sinon il reste le mot « Contour »
     devant rien. On remet etat.bordure a zero — c est le seul chemin par
     lequel la bordure atteint l apercu, le trace de coupe (scdm-forme.js) et
     la commande (scdm-contour-mm.js) — donc aucune surface de contour ne peut
     etre dessinee ni facturee.

     ON GARDE LA VALEUR D AVANT, ET ON LA REND. Le vernis et le laminage
     retombent a « rien » et n ont rien a rendre. Le contour, lui, part d une
     valeur utile (0,04, soit quelques millimetres) : la perdre en passant par
     le lettrage laisserait le client avec une coupe franche dans son dessin au
     retour sur un vinyle imprime, sans qu il ait rien demande. Un zero pose
     expres par le client, lui, est respecte : on ne range que ce qui est
     superieur a zero. */
  function contour(lettrage) {
    var b = document.getElementById('scdmBordure');
    if (!b) return false;
    var l = document.querySelector('label[for="scdmBordure"]');
    var e = etat();
    var change = false;

    [b, l].forEach(function (n) {
      if (!n) return;
      if (n.hidden !== lettrage) n.hidden = lettrage;
      var d = lettrage ? 'none' : '';
      if (n.style.display !== d) n.style.display = d;
    });

    if (!e) return false;
    if (lettrage) {
      if (Number(e.bordure) > 0) {
        bordureGardee = Number(e.bordure);
        e.bordure = 0;
        b.value = '0';
        change = true;
      }
    } else if (bordureGardee !== null && Number(e.bordure) === 0) {
      e.bordure = bordureGardee;
      b.value = String(bordureGardee);
      bordureGardee = null;
      change = true;
    }
    return change;
  }

  /* --------------------------------------------------- 3. LE LAMINAGE */

  /* laminageOffert() de scdm.js rend vrai des 144 po2 : a 20 x 20 po la
     rangee se rouvrait sur du lettrage. On la referme de la MEME facon que
     scdm.js ferme les siennes — hidden ET display:none sur le .fld entier,
     libelle, case et phrase ensemble — et on remet etat.laminage a « aucun ».

     C EST LA VALEUR QUI TIENT LE PRIX, pas l affichage. laminageCourant() de
     scdm.js lit etat.laminage ; a « aucun » il rend l objet neutre — aucun
     tarif au pouce carre, aucun montage — donc ni les 4,00 $/pi2 ni les 30 $
     de montage ne peuvent entrer dans le total, meme le temps d un rendu.

     Le laminage n est PAS un choix obligatoire de scdm-vierge.js : le cacher
     ne peut pas rendre le bouton muet. */
  function laminage(lettrage) {
    var rl = document.getElementById('scdmLaminages');
    if (!rl) return false;
    var fld = (rl.closest && rl.closest('.fld')) || rl;
    var e = etat();
    var change = false;

    if (lettrage) {
      if (!fld.hidden) fld.hidden = true;
      if (fld.style.display !== 'none') fld.style.display = 'none';
      if (e && e.laminage !== 'aucun') { e.laminage = 'aucun'; change = true; }
    }
    return change;
  }

  /* ------------------------------------------------------- la veille */

  /* scdm.js repeint ses rangees a chaque rafraichir() : il rouvre la rangee du
     laminage et remontre le curseur des qu il repasse par la. On repasse donc
     derriere lui. La veille est courte (60 ms) pour que rien ne clignote a
     l ecran, et elle ne touche au DOM que lorsque l etat n est pas deja le
     bon : aucun travail inutile entre deux clics. */
  function veiller() {
    var e = etat();
    if (!e) return;
    var lettrage = estLettrage();
    var a = contour(lettrage);
    var b = laminage(lettrage);
    /* Un etat qui a bouge doit se voir : on redemande un rendu. */
    if (a || b) redessiner();
  }

  /* ------------------------------------------------------- demarrage */

  function demarrer() {
    cv = document.getElementById('scdmCanvas');
    if (!cv) return false;
    ctx = cv.getContext('2d');
    brancher();
    veiller();
    setInterval(veiller, 60);
    ['click', 'input', 'change'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(veiller, 0); }, true);
    });
    return true;
  }

  function quandPret(n) {
    if (document.getElementById('scdmCanvas') && window.SCDM && window.SCDM_DATA) {
      if (demarrer()) return;
    }
    if ((n || 0) > 120) return;
    setTimeout(function () { quandPret((n || 0) + 1); }, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { quandPret(0); });
  } else {
    quandPret(0);
  }
})();
